import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import { IconButton, Typography } from "@mui/material";
import React from "react";

interface EnableChunkingButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

const EnableChunkingButton = ({ onClick, disabled = false }: EnableChunkingButtonProps): React.ReactElement => (
  <IconButton
    size="small"
    color="primary"
    onClick={onClick}
    disabled={disabled}
    sx={{
      ml: 1,
      border: "1px solid",
      borderColor: "primary.main",
      borderRadius: 1,
      padding: "2px 8px",
      // eslint-disable-next-line @typescript-eslint/naming-convention
      "&:hover": {
        bgcolor: "primary.main",
        color: "white"
      }
    }}
  >
    <AutoAwesomeIcon fontSize="small" sx={{ mr: 0.5 }} />
    <Typography variant="caption">Enable Chunked Processing</Typography>
  </IconButton>
);

export default EnableChunkingButton;
